/**
 * Renders whatever `askConfirm` is currently asking. Mounted once, near the root, so no feature
 * has to remember to host a dialog — the reason the old confirms drifted was that each surface
 * owned its own mount and therefore its own markup.
 */
import { useSyncExternalStore } from 'react';
import {
  confirmServerSnapshot,
  currentConfirm,
  resolveConfirm,
  subscribeConfirm,
} from './confirmStore';
import { ConfirmDialog } from './ConfirmDialog';

export function ConfirmHost() {
  const pending = useSyncExternalStore(subscribeConfirm, currentConfirm, confirmServerSnapshot);
  if (!pending) return null;

  const { id, request } = pending;
  const { secondaryLabel, ...rest } = request;

  return (
    <ConfirmDialog
      // Remount per question so the input's value and the armed state never leak between asks.
      key={id}
      {...rest}
      secondary={
        secondaryLabel
          ? {
              label: secondaryLabel,
              onSelect: () => resolveConfirm(id, { action: 'secondary', value: '' }),
            }
          : undefined
      }
      onConfirm={(value) => resolveConfirm(id, { action: 'confirm', value })}
      onCancel={() => resolveConfirm(id, { action: 'cancel', value: '' })}
      onDismiss={() => resolveConfirm(id, { action: 'dismiss', value: '' })}
    />
  );
}
